import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../_store";
import { categoryUpdate, categoriesList, categoryDelete } from "../../../_store/thunks/category.thunk";
import DeleteButton from "../../../components/DeleteButton";
import SubmitButton from "../../../components/SubmitButton";
import { ICategory } from "../../../models/ICategory";

interface CategoryEditProps {
    setErrorAlert: any;
    category: ICategory | null;
}

export default function CategoryEdit(props: CategoryEditProps) {

    const dispatch = useDispatch<AppDispatch>();
    const categories = useSelector((state: RootState) => state.category.categories);

    const [category, setCategory] = useState<ICategory | null>();
    const [hasChanges, setHasChanges] = useState(false);
    const [showConfirmDeletionModal, setShowConfirmDeletionModal] = useState(false);

    useEffect(() => {
        setCategory(props.category);
    }, [props.category])

    function editCategoryState(fieldName: string, value: any) {
        setCategory((prev) => ({ ...prev, [fieldName]: value } as ICategory));
        setHasChanges(true);
    }

    const updateCategory = (event: any) => {
        event.preventDefault();
        if (category) {
            dispatch(categoryUpdate(category)).then((x: any) => {
                if (x.error) {
                    props.setErrorAlert(x.error.message);
                }
                else {
                    dispatch(categoriesList());
                }
            });
        }
    }
    const showConfirmDeletion = (event: any) => {
        event.preventDefault();
        setShowConfirmDeletionModal(true);
    }

    const deleteCategory = (event: any) => {
        event.preventDefault();
        if (category) {
            dispatch(categoryDelete(category.id)).then((x: any) => {
                if (x.error) {
                    props.setErrorAlert(x.error.message);
                }
                else {
                    setShowConfirmDeletionModal(false);
                    dispatch(categoriesList());
                }
            });
        }
    }

    return (
        <>
            {category &&
                <>
                    <Form onSubmit={updateCategory}>
                        {category.parentId &&
                            <Form.Group className="mb-3">
                                <Form.Label>Родительская категория:</Form.Label>
                                <Form.Select id="parentId"
                                    value={category.parentId}
                                    onChange={(event) => editCategoryState("parentId", Number(event.target.value))}>
                                    {categories?.map(main =>
                                        (<option key={main.id} value={main.id}>{main.name}</option>))}
                                </Form.Select>
                            </Form.Group>
                        }

                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label>Название:</Form.Label>
                            <Form.Control type="text"
                                value={category.name}
                                onChange={(event) => editCategoryState("name", event.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>Описание:</Form.Label>
                            <Form.Control type="text"
                                value={category.description}
                                onChange={(event) => editCategoryState("description", event.target.value)} />
                        </Form.Group>

                        <SubmitButton disabled={!hasChanges} />
                        <DeleteButton onClick={() => showConfirmDeletion} size={undefined} />
                    </Form>

                    <Modal show={showConfirmDeletionModal} onHide={() => setShowConfirmDeletionModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Точно удалить категорию {category.name}?</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button variant='outline-secondary' onClick={() => setShowConfirmDeletionModal(false)}>
                                Отмена
                            </Button>
                            <Button variant='outline-danger' onClick={() => deleteCategory}>
                                Удалить
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            }
        </>
    );
}